import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ArrowRightIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M13.071 12.0001L9.24995 15.8211C8.83595 16.2351 8.83595 16.9071 9.24995 17.3211C9.66395 17.7351 10.336 17.7351 10.75 17.3211L15.364 12.7071C15.755 12.3161 15.755 11.6831 15.364 11.2931L10.75 6.67909C10.336 6.26509 9.66395 6.26509 9.24995 6.67909C8.83595 7.09309 8.83595 7.76509 9.24995 8.17909L13.071 12.0001Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ArrowRightIcon.propTypes = {
  sx: PropTypes.object,
};

export default ArrowRightIcon;
